import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            component: () => import("@/views/Site"),
            // redirect: "app/main"
        },
        {
            path: '/app',
            component: () => import("@/layouts/AuthorizedLayout"),
            redirect: 'app/main',
            children: [
                {
                    path: 'korzinka',
                    component: () => import('@/layouts/korzinka.layout'),
                    children: [
                        {
                            path: '',
                            redirect: {name: 'korzinka-dashboard'},
                        },
                        {
                            path: 'dashboard',
                            name: 'korzinka-dashboard',
                            component: () => import('@/views/korzinka/korzinka.dashboard')
                        },
                        {
                            path: 'acts/in',
                            name: 'korzinka-acts-in',
                            component: () => import('@/views/korzinka/korzinka.in.act')
                        },
                        {
                            path: 'acts/out',
                            name: 'korzinka-acts-out',
                            component: () => import('@/views/korzinka/korzinka.out.act')
                        }
                    ]
                },
                {
                    path: 'main',
                    component: () => import("@/layouts/Main"),
                    children: [
                        {
                            path: '',
                            name: 'home',
                            component: () => import("@/views/main/Home"),
                            redirect: {name: 'dashboard'}
                        },
                        {
                            path: 'dashboard',
                            name: 'dashboard',
                            component: () => import("@/views/main/Dashboard")
                        },

                        {
                            path: 'order',
                            name: 'order',
                            component: () => import("@/views/main/Order"),
                            redirect: {name: 'orders-all'},
                            meta: {
                                expandOrders: true
                            },
                            children: [
                                {
                                    path: 'all',
                                    name: 'orders-all',
                                    component: () => import("@/views/main/order/box/OrderAllBoxView")
                                },
                                {
                                    path: 'reject',
                                    name: 'orders-rejectBox',
                                    component: () => import("@/views/main/order/box/OrderDeclinedBoxView")
                                },
                                {
                                    path: 'complete',
                                    name: 'orders-completeBox',
                                    component: () => import("@/views/main/order/box/OrderCompleteBoxView")
                                },
                                {
                                    path: 'processing',
                                    name: 'orders-processingBox',
                                    component: () => import("@/views/main/order/box/OrderProcessingBoxView")
                                },
                                {
                                    path: 'stopped',
                                    name: 'orders-stoppedBox',
                                    component: () => import("@/views/main/order/box/OrderStoppedBoxView")
                                },
                                {
                                    path: 'add',
                                    name: 'order-add',
                                    component: () => import("@/views/main/order/AddOrder"),
                                },
                                {
                                    path: ':id/edit',
                                    name: 'order-edit',
                                    component: () => import("@/views/main/order/EditOrder"),
                                },
                                {
                                    path: ':id',
                                    name: 'order-page',
                                    component: () => import("@/views/main/order/OrderView"),
                                }
                            ]
                        },
                        {
                            path: 'shipment',
                            name: 'shipment',
                            component: () => import("@/views/main/ShipmentWaybill"),
                            meta: {
                                expandShipments: true
                            },
                            redirect: {name: 'shipment-all'},
                            children: [
                                {
                                    path: 'all',
                                    name: 'shipment-all',
                                    component: () => import("@/views/main/shipment/box/ShipmentAllBoxView")
                                },
                                {
                                    path: 'complete',
                                    name: 'shipment-completeBox',
                                    component: () => import("@/views/main/shipment/box/ShipmentCompleteBoxView")
                                },
                                {
                                    path: 'decline',
                                    name: 'shipment-declineBox',
                                    component: () => import("@/views/main/shipment/box/ShipmentDeclineBoxView")
                                },
                                {
                                    path: 'processing',
                                    name: 'shipment-processingBox',
                                    component: () => import("@/views/main/shipment/box/ShipmentProcessingBoxView")
                                },
                                {
                                    path: 'deleted',
                                    name: 'shipment-deletedBox',
                                    component: () => import("@/views/main/shipment/box/ShipmentDeletedBoxView")
                                },
                                {
                                    path: 'delivery-today',
                                    name: 'shipment-deliveryTodayBox',
                                    component: () => import("@/views/main/shipment/box/ShipmentTodayDeliveryBoxView")
                                },
                                {
                                    path: 'new/self/:orderId',
                                    name: 'add-self-shipment',
                                    component: () => import('@/views/main/shipment/AddShipmentView')
                                },
                                {
                                    path: ':id/edit',
                                    name: 'shipment-edit',
                                    component: () => import("@/views/main/shipment/EditShipmentView")
                                },
                                {
                                    path: ':id',
                                    name: 'shipment-page',
                                    component: () => import("@/views/main/shipment/ShipmentView")
                                },
                            ]
                        },
                        {
                            path: 'invoice',
                            name: 'invoice',
                            component: () => import("@/views/main/Invoice"),
                            redirect: {name: 'invoice-all'},
                            meta: {
                                expandInvoices: true
                            },
                            children: [
                                {
                                    path: 'by-shipment-2/:id/new',
                                    name: 'new-invoice-by-shipment-2',
                                    component: () => import("@/views/main/invoice/AddInvoiceView")
                                },
                                {
                                    path: 'all',
                                    name: 'invoice-all',
                                    component: () => import("@/views/main/invoice/box/InvoiceAllBoxView")
                                },
                                {
                                    path: 'complete',
                                    name: 'invoice-completeBox',
                                    component: () => import("@/views/main/invoice/box/InvoiceCompleteBoxView")
                                },
                                {
                                    path: 'processing',
                                    name: 'invoice-processingBox',
                                    component: () => import("@/views/main/invoice/box/InvoiceProcessingBoxView")
                                },
                                {
                                    path: 'reject',
                                    name: 'invoice-reject-box',
                                    component: () => import("@/views/main/invoice/box/InvoiceRejectBoxView")
                                },
                                {
                                    path: ':id',
                                    name: 'invoice-page',
                                    component: () => import("@/views/main/invoice/InvoiceView"),
                                }
                            ]
                        },

                        {
                            path: 'return-order',
                            name: 'return-order',
                            component: () => import("@/views/main/ReturnOrder"),
                            meta: {
                                expandReturnOrders: true
                            },
                            redirect: {name: 'return-order-all'},
                            children: [
                                {
                                    path: 'all',
                                    name: 'return-orders-all',
                                    component: () => import('@/views/main/return-order/box/ReturnOrderAllBoxView')
                                },
                                {
                                    path: 'add',
                                    name: 'return-order-add',
                                    component: () => import("@/views/main/return-order/AddReturnOrder"),
                                },
                                {
                                    path: ':id/edit',
                                    name: 'return-order-edit',
                                    component: () => import("@/views/main/return-order/EditReturnOrder"),
                                },
                                {
                                    path: ':id',
                                    name: 'return-order-page',
                                    component: () => import("@/views/main/return-order/ReturnOrderView"),
                                }
                            ]
                        },
                        {
                            path: 'return-shipment',
                            name: 'return-shipment',
                            component: () => import("@/views/main/ReturnShipment"),
                            meta: {
                                expandReturnShipments: true
                            },
                            redirect: {name: 'return-shipment-all'},
                            children: [
                                {
                                    path: 'all',
                                    name: 'return-shipment-all',
                                    component: () => import("@/views/main/return-shipment/box/ReturnShipmentAllBoxView")
                                },
                                {
                                    path: 'new/self/:orderId',
                                    name: 'add-self-return-shipment',
                                    component: () => import('@/views/main/return-shipment/AddReturnShipmentView')
                                },
                                {
                                    path: ':id/edit',
                                    name: 'return-shipment-edit',
                                    component: () => import("@/views/main/return-shipment/EditReturnShipmentView")
                                },
                                {
                                    path: ':id',
                                    name: 'return-shipment-page',
                                    component: () => import("@/views/main/return-shipment/ReturnShipmentView")
                                },
                            ]
                        },
                        {
                            path: 'return-invoice',
                            name: 'return-invoice',
                            component: () => import("@/views/main/ReturnInvoice"),
                            meta: {
                                expandReturnInvoices: true
                            },
                            children: [
                                {
                                    path: 'all',
                                    name: 'return-invoices-all',
                                    component: () => import("@/views/main/return-invoice/box/ReturnInvoiceAllBoxView")
                                },
                                /*{
                                    path: 'processing',
                                    name: 'return-invoices-processing',
                                    component: () => import("@/views/main/return-invoice/box/ReturnInvoiceProcessingBoxView")
                                },
                                {
                                    path: 'complete',
                                    name: 'return-invoices-complete',
                                    component: () => import("@/views/main/return-invoice/box/ReturnInvoiceCompleteBoxView")
                                },*/
                                {
                                    path: 'add/:id',
                                    name: 'add-return-invoice',
                                    component: () => import('@/views/main/return-invoice/AddReturnInvoiceView')
                                },
                                {
                                    path: ':id',
                                    name: 'return-invoice-page',
                                    component: () => import("@/views/main/return-invoice/ReturnInvoicePage")
                                }
                            ]
                        },

                        {
                            path: 'attorney/company/:id/view',
                            name: 'company-attorney-view',
                            component: () => import("@/views/main/attorney/CompanyAttorneyPage")
                        },
                        {
                            path: 'attorney/:shipmentWaybillId/new',
                            name: 'new-attorney',
                            component: () => import("@/views/main/attorney/NewAttorney")
                        },
                        {
                            path: 'attorney/:id',
                            name: 'attorney-page',
                            component: () => import("@/views/main/attorney/AttorneyPage")
                        },
                        {
                            path: 'attorney-contraction',
                            name: 'contraction-attorney-view',
                            component: () => import("@/views/main/attorney/ContractionAttorneyView")
                        },

                        {
                            path: 'settings',
                            name: 'settings',
                            component: () => import("@/views/main/Settings")
                        },
                        {
                            path: 'directory',
                            name: 'directory',
                            component: () => import("@/views/main/Directory"),
                            redirect: {name: 'directories'},
                            children: [
                                {
                                    path: 'home',
                                    name: 'directories',
                                    component: () => import("@/views/main/directory/Directories")
                                },
                                {
                                    path: 'contractions',
                                    name: 'directory-contractions',
                                    component: () => import("@/views/main/directory/ContractionsPage")
                                },
                                {
                                    path: 'products',
                                    name: 'directory-products',
                                    component: () => import("@/views/main/directory/ProductsPage")
                                },
                                {
                                    path: 'attorneys',
                                    name: 'directory-attorneys',
                                    component: () => import("@/views/main/directory/AttorneysPage")
                                },
                                {
                                    path: 'products-specification',
                                    name: 'directory-products-specification',
                                    component: () => import("@/views/main/directory/ProductsSpecificationPage")
                                }
                            ]
                        },
                        {
                            name: 'roaming',
                            path: 'roaming',
                            component: () => import("@/views/main/roaming/Roaming"),
                            redirect: {name: 'roaming-inbox'},
                            meta: {
                                expandRoaming: true
                            },
                            children: [
                                {
                                    path: 'inbox',
                                    name: 'roaming-inbox',
                                    component: () => import("@/views/main/roaming/RoamingInbox")
                                },
                                {
                                    path: 'income-complete',
                                    name: 'roaming-income-complete',
                                    component: () => import("@/views/main/roaming/RoamingIncomeSignedBox")
                                },
                                {
                                    path: 'out-complete',
                                    name: 'roaming-out-complete',
                                    component: () => import("@/views/main/roaming/RoamingOutgoSignedBox")
                                },
                                {
                                    path: 'income-match',
                                    name: 'roaming-income-match',
                                    component: () => import("@/views/main/roaming/RoamingIncomeMatchBox")
                                },
                                {
                                    path: 'out-match',
                                    name: 'roaming-out-match',
                                    component: () => import("@/views/main/roaming/RoamingOutgoMatchBox")
                                },
                                {
                                    path: 'income-half-match',
                                    name: 'roaming-income-half-match',
                                    component: () => import("@/views/main/roaming/RoamingIncomeHalfMatchBox")
                                },
                            ]
                        },
                        {
                            path: 'statistics',
                            name: 'statistics',
                            component: () => import("@/views/main/statistics/StatisticsLayout"),
                            redirect: {name: 'statistics-dashboard'},
                            children: [
                                {
                                    path: 'dashboard',
                                    component: () => import("@/views/main/statistics/StatisticsDashboardPage"),
                                    name: 'statistics-dashboard'
                                }
                            ]

                        },
                        {
                            path: 'contract',
                            name: 'contract',
                            component: () => import('@/views/main/Contract'),
                            redirect: {name: 'contracts-all'},
                            meta: {
                                expandContracts: true
                            },
                            children: [
                                {
                                    path: 'all',
                                    name: 'contracts-all',
                                    component: () => import('@/views/main/contract/box/ContractAllBoxView')
                                },
                                {
                                    path: 'add',
                                    name: 'add-contract',
                                    component: () => import("@/views/main/contract/AddContractView"),
                                },
                                {
                                    path: 'add-from-sent-approve/:id',
                                    name: 'add-from-sent-approve',
                                    component: () => import("@/views/main/contract/AddContractFromSentApproveView")
                                },
                                {
                                    path: 'view/:id',
                                    name: 'view-contract',
                                    component: () => import("@/views/main/contract/ContractView")
                                },
                                {
                                    path: 'edit/:id',
                                    name: 'edit-contract',
                                    component: () => import("@/views/main/contract/EditContractView")
                                }
                            ]
                        },
                        {
                            path: 'send-contract-approve',
                            name: 'send-contract-approve',
                            component: () => import('@/views/main/Contract'),
                            redirect: {name: 'send-contract-approves-all-by-customer'},
                            meta: {
                                expandSendContractApproves: true
                            },
                            children: [
                                {
                                    path: 'all-by-customer',
                                    name: 'send-contract-approves-all-by-customer',
                                    component: () => import('@/views/main/send-contract-approve/box/SendContractApproveAllBoxByCustomerView')
                                },
                                {
                                    path: 'all-by-executor',
                                    name: 'send-contract-approves-all-by-executor',
                                    component: () => import('@/views/main/send-contract-approve/box/SendContractApproveAllBoxByExecutorView')
                                }
                            ]
                        },
                    ]
                }
            ]
        }
    ]
})
